import React from 'react';
import { qualifikationLabels } from '../../lib/utils';

function NotSanSymbol({ large }) {
  return (
    <span className="flex shrink-0 flex-col items-center gap-0.5 text-blue-700 dark:text-blue-400"
      role="img" aria-label="Notfallsanitäter (NFS)" title="Notfallsanitäter (NFS)">
      <svg viewBox="0 0 40 40" className={large ? "h-9 w-9" : "h-7 w-7"} aria-hidden="true">
        <g fill="currentColor">
          <path d="M15 2h10v36H15z" />
          <path d="M15 2h10v36H15z" transform="rotate(60 20 20)" />
          <path d="M15 2h10v36H15z" transform="rotate(120 20 20)" />
        </g>
        <path d="M20 9v23" stroke="white" strokeWidth="1.7" strokeLinecap="round" />
        <path d="M23 11c-8-3-10 5-3 7s7 6 0 8c-4 1-3 3-1 4"
          fill="none" stroke="white" strokeWidth="1.7" strokeLinecap="round" />
        <ellipse cx="23" cy="11" rx="2" ry="1.3" fill="white" />
      </svg>
      <span className="text-[9px] font-bold leading-none tracking-wider">NFS</span>
    </span>
  );
}

export default function QualificationMark({ qualification, large = false }) {
  if (!qualification || qualification === 'NONE') return null;
  if (qualification === 'NotSan' || qualification === 'NFS') return <NotSanSymbol large={large} />;
  return <span className={large
    ? 'text-base font-semibold tracking-wide text-slate-700 dark:text-slate-200'
    : 'text-[10px] font-semibold tracking-wide text-slate-700 dark:text-slate-200'}
    role="img" title={qualifikationLabels[qualification] || qualification}
    aria-label={qualifikationLabels[qualification] || qualification}>{qualification}</span>;
}
